// extracted by mini-css-extract-plugin
export default {"userInfo":"sOrgE","button":"p2urI","toggler":"ckY7N","opened":"EfhaB","menu":"sEIjx","icon":"owiPg","multi":"HLHnz","iconSecond":"RuLcI"};